import { EmployeeBookingReportsComponent } from './employee-booking-reports/employee-booking-reports.component';
import { ReportsFilterComponent } from './filter/filter.component';
import { HaltReportsComponent } from './halt-reports/halt-reports.component';
import { MomentReportsComponent } from './moment-reports/moment-reports.component';
import { OfflineReportComponent } from './offline/offline-component';
import { OverspeedReportsComponent } from './over-speed-reports/over-speed-reports.component';
import { ProductivityComponent } from './productivity-reports/productivity-reports.component';
import { ReportsComponent } from './reports.component';
import { SosReportComponent } from './sos-report/sos-report.component';
import { VehicleBookingHistoryReportsComponent } from './vehicle-booking-history-reports/vehicle-booking-history-reports.component';
import { RouteBookingReportsComponent } from './route-booking-report/route-booking-reports.component'
import { OpenBookingMenuComponent } from './directives/open-booking-menu/open-booking-menu';
import { SafeDropComponent } from './safe-drop/safe-drop-component';
import { TripReportsComponent } from './trip-reports/trip-reports-component';
import { TripCountsComponent } from './trip-reports/trip-counts/trip-counts.component';
import { ComplaintRatingsComponent } from './complaint-ratings/complaint-ratings.component';
import { AppInstallationReportComponent } from './app-installation-report/app-installation-report.component';
import { DriverAppInstallationReportComponent } from './app-installation-report/driver-app-installation-report/driver-app-installation-report.component';
import { EmpAppInstallationReportComponent } from './app-installation-report/emp-app-installation-report/emp-app-installation-report.component';
import { AppReportsMenuComponent } from './app-installation-report/app-reports-menu/app-reports-menu.component';
import { ExcessEmployeeReportComponent } from './excess-employee-report/excess-employee-report.component';
import { SecuritycheckComponent } from './attendance-reports/securitycheck/securitycheck.component';
import { MenuComponent } from './attendance-reports/directives/menu/menu.component';
import { AttendanceReportPreviewComponent } from './attendance-reports/directives/attendance-report-preview/attendance-report-preview.component';
import { AttendanceReportsComponent } from './attendance-reports/attendance-reports.component';
import { EmployeeBookingCountComponent } from './employee-booking-count/employee-booking-count.component';
import { HeadReportsComponent } from './head-reports/head-reports.component';
import { HeadReportMenuComponent } from './directives/head-report-menu/head-report-menu.component';
import { VehicleWiseReportComponent } from './vehicle-wise-report/vehicle-wise-report.component';
import { NoShowReportComponent } from './no-show-report/no-show-report.component';
import { GeoReportsComponent } from './geo-reports/geo-reports.component';
import { TripReportMenuComponent } from './directives/trip-report-menu/trip-report-menu.component';
import { RosterTripCountsComponent } from './roster-trip-counts/roster-trip-counts.component';
import {NewRosterTripCountsComponent} from './new-roster-trip-counts/new-roster-trip-counts.component';
import { VehicleAuditReportComponent } from './vehicle-audit-report/vehicle-audit-report.component';
import { TowAlertReportComponent } from './towalert-report/towalert-report.component';
import {NightRideReportsComponent} from './night-ride-reports/night-ride-reports.component'; 
import { ContinuousDrivingComponent} from './continuous-driving-reports/continuous-driving-reports.component';
import { DriverAppUsageReportsComponent } from './driver-app-usage-reports/driver-app-usage-reports.component';
import {HarshAccelerationReportComponent} from './harsh-acceleration-report/harsh-acceleration-report.component';

export const ReportsDeclaration = [
    MomentReportsComponent,
    HaltReportsComponent,
    OverspeedReportsComponent,
    SosReportComponent,
    ReportsComponent,
    ProductivityComponent,
    ReportsFilterComponent,
    OfflineReportComponent,
    EmployeeBookingReportsComponent,
    VehicleBookingHistoryReportsComponent,
    RouteBookingReportsComponent,
    SafeDropComponent,
    TripReportsComponent,
    TripCountsComponent,
    OpenBookingMenuComponent,
    AttendanceReportsComponent,
    SecuritycheckComponent,
    ComplaintRatingsComponent,
    AppReportsMenuComponent,
    AppInstallationReportComponent,
    DriverAppInstallationReportComponent,
    EmpAppInstallationReportComponent,
    ExcessEmployeeReportComponent,
    MenuComponent,
    AttendanceReportPreviewComponent,
    EmployeeBookingCountComponent,
    HeadReportsComponent,
    HeadReportMenuComponent,
    VehicleWiseReportComponent,
    NoShowReportComponent,
    GeoReportsComponent,
    TripReportMenuComponent,
    RosterTripCountsComponent,
    VehicleAuditReportComponent,
    NewRosterTripCountsComponent,
    TowAlertReportComponent,
    NightRideReportsComponent,
    ContinuousDrivingComponent,
    DriverAppUsageReportsComponent,HarshAccelerationReportComponent
];
